import { DEFAULTS } from "../../../Constant";
import "./index.css";
import { TextField } from "@mui/material";

const CustomInput = (props) => {
  const { component = DEFAULTS.DEFAULT } = props;
  return (
    <div className={props.remove_class ? "" : "customInputWrpr"}>
      {props.upperLabel ? (
        <div className="labelInput">
          <p>{props.label}</p>
          {props.multiline ? (
            <TextField
              variant="outlined"
              // error={props?.errorMsg}
              // helperText={props?.errorMsg}
              name={props.name}
              autoFocus={props.autofocus}
              type={props.type ? props.type : "text"}
              value={props.value}
              onBlur={props.onBlur}
              placeholder={props.placeholder}
              onChange={(e) => {
                props.onChange(e);
                if (component === DEFAULTS.DEFAULT)
                  props.formik.setFieldValue(
                    props.name,
                    e.target.value.toUpperCase()
                  );
              }}
              disabled={props.disabled}
              multiline
              rows={props.rows}
              inputProps={{
                readOnly: props.readOnly,
              }}
              InputLabelProps={{ shrink: props.shrink }}
            />
          ) : (
            <TextField
              variant="outlined"
              accept={props.accept}
              name={props.name}
              // error={props?.errorMsg}
              // helperText={props?.errorMsg}
              type={props.type ? props.type : "text"}
              value={props.value}
              onBlur={props.onBlur}
              placeholder={props.placeholder}
              onChange={(e) => {
                props.onChange(e);
                if (component === DEFAULTS.DEFAULT)
                  props.formik.setFieldValue(
                    props.name,
                    e.target.value.toUpperCase()
                  );
              }}
              min={props.min}
              autoComplete={props.autoComplete}
              size="small"
              inputProps={{ readOnly: props.readOnly }}
              disabled={props.disabled}
              onPaste={props.onPaste}
              InputLabelProps={{ shrink: props.shrink }}
              InputProps={{
                startAdornment: props.startAdornment,
                endAdornment: props.endAdornment,
                readOnly: props.readOnly,
              }}
              onWheel={
                props.type === "number" ? (e) => e.target.blur() : props.onWheel
              }
              autoFocus={props.autoFocus}
            />
          )}
        </div>
      ) : (
        <>
          {props.multiline ? (
            <TextField
              label={props.label}
              variant="outlined"
              name={props.name}
              type={props.type ? props.type : "text"}
              value={props.value}
              onBlur={props.onBlur}
              placeholder={props.placeholder}
              onChange={(e) => {
                props.onChange(e);
                if (component === DEFAULTS.DEFAULT)
                  props.formik.setFieldValue(
                    props.name,
                    e.target.value.toUpperCase()
                  );
              }}
              disabled={props.disabled}
              multiline
              // error={props?.errorMsg}
              // helperText={props?.errorMsg}
              rows={props.rows}
              InputLabelProps={{ shrink: props.shrink }}
              InputProps={{
                startAdornment: props.startAdornment,
                endAdornment: props.endAdornment,
                readOnly: props.readOnly,
              }}
            />
          ) : (
            <TextField
              label={props.label}
              variant="outlined"
              accept={props.accept}
              name={props.name}
              ref={props.reference}
              type={props.type ? props.type : "text"}
              value={props.value}
              onBlur={props.onBlur}
              placeholder={props.placeholder}
              size={props.size ? props.size : "small"}
              min={props.min}
              onChange={(e) => {
                props.onChange(e);
                if (component === DEFAULTS.DEFAULT)
                  props.formik.setFieldValue(
                    props.name,
                    e.target.value.toUpperCase()
                  );
              }}
              InputLabelProps={{ shrink: props.shrink }}
              InputProps={{
                startAdornment: props.startAdornment,
                endAdornment: props.endAdornment,
                readOnly: props.readOnly,
              }}
              autoComplete={props.autoComplete}
              disabled={props.disabled}
              onPaste={props.onPaste}
              onWheel={
                props.type === "number" ? (e) => e.target.blur() : props.onWheel
              }
              autoFocus={props.autoFocus}
            />
          )}
        </>
      )}
      {props.errorMsg ? (
        <p className={`errMsg ${props.errorMsgCls}`}>{props.errorMsg}</p>
      ) : props.formik?.touched[props.name] &&
        props.formik?.errors[props.name] ? (
        <p className="errMsg">{props.formik.errors[props.name]}</p>
      ) : (
        ""
      )}
    </div>
  );
};

export default CustomInput;
